import { SupplierAccountWebService } from '@linktivity/gds-neo';
import { createServiceConfig } from '../config';

const config = createServiceConfig({
  Configuration: SupplierAccountWebService.Configuration
});

export default config;
